export const FAVORITES = "/main/favorites";
export const FEATURED = "/main/featured";
export const MAP = "/main/map";
export const SETTINGS = "/main/settings";
